import $ from 'jquery';

function checkForSubmenu(el) {
    const hasActiveSubmenu = $('.menu__item--ancestor.menu__item--has-children .js-toggle-children');
    if (hasActiveSubmenu.length !== 0) {
        $(el).addClass('header--has-active-submenu');
    }
}

export default checkForSubmenu;
